// src/context/ToastContext.js
import React, { createContext, useState, useContext } from "react";

// Create a Toast Context
const ToastContext = createContext();

// ToastProvider to manage toast messages globally
export const ToastProvider = ({ children }) => {
    const [toastMessage, setToastMessage] = useState("");
    const [toastType, setToastType] = useState("");  // success or error

    const showToast = (message, type) => {
        setToastMessage(message);
        setToastType(type);

        // Auto dismiss after 4 seconds
        setTimeout(() => {
            setToastMessage("");
            setToastType("");
        }, 4000);
    };

    return (
        <ToastContext.Provider value={{ toastMessage, toastType, showToast }}>
            {children}
        </ToastContext.Provider>
    );
};

// Hook to use Toast context
export const useToast = () => {
    return useContext(ToastContext);
};
